import React from 'react';

import { Box, Divider } from '@mui/material';
import { useInView } from 'react-intersection-observer';

import AboutCompany from './aboutCompany';
import Contact from './contact';
import DescriptionAndAddress from './descriptionAndAddress';
import DownloadApp from './downloadApp';
import OnlineCourse from './onlineCourse';
import PolicyFooter from './policyFooter';

import { useAppData, useBreakpointV3 } from '@helpers/use';

const Footer = ({ hideDownloadApp }: { hideDownloadApp?: boolean }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1, rootMargin: '300px' });
  const { appData } = useAppData();
  const { isMobile } = useBreakpointV3();

  const phoneNumberAndOfficeHours = appData?.footer?.phone_number_and_office_hours;
  const FACEBOOK_URL = appData?.footer?.facebookUrl || '';
  const LINE_URL = appData?.footer?.lineUrl || '';
  const GOOGLE_PLAY_URL = appData?.footer?.googleStoreUrl || '';
  const APP_STORE_URL = appData?.footer?.appStoreUrl || '';

  return (
    <Box ref={ref}>
      {inView && (
        <>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              py: '48px',
              gap: '24px',
              justifyContent: 'center',
              width: '100%',
              px: { lg: 0, xs: '24px' },
              flexDirection: { md: 'row', xs: 'column' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                width: { lg: '25%', md: '50%' },
                justifyContent: { lg: 'flex-start', md: 'space-between' },
              }}
            >
              <DescriptionAndAddress />

              {!isMobile && !hideDownloadApp && (
                <DownloadApp GOOGLE_PLAY_URL={GOOGLE_PLAY_URL} APP_STORE_URL={APP_STORE_URL} />
              )}
            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: { lg: '48px', md: '32px', xs: '24px' },
                flexDirection: { lg: 'row', xs: 'column' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: { md: '48px', xs: '24px' },
                  flexDirection: { md: 'row', xs: 'column' },
                }}
              >
                <OnlineCourse />
                <AboutCompany />
              </Box>

              <Contact
                phoneNumberAndOfficeHours={phoneNumberAndOfficeHours}
                FACEBOOK_URL={FACEBOOK_URL}
                LINE_URL={LINE_URL}
              />
            </Box>
            {isMobile && !hideDownloadApp && (
              <DownloadApp GOOGLE_PLAY_URL={GOOGLE_PLAY_URL} APP_STORE_URL={APP_STORE_URL} />
            )}
          </Box>
          <PolicyFooter />
        </>
      )}
    </Box>
  );
};

export default Footer;
